import { Injectable } from '@angular/core';
import { BarcodeScannedAction } from '../+state';

@Injectable()
export abstract class ScannerAdapterServiceBase {
  constructor() {}

  public abstract showScanner(actionToDispatchOnBarcodeScanned: BarcodeScannedAction): void;

  public abstract closeScaner(): void;

  public abstract startScanning(): void;

  public abstract stopScanning(): void;

  public abstract resumeScanning(): void;

  public abstract pauseScanning(): void;

  public abstract changeMargins(): void;
}
